import { create } from "zustand";

/**
 * The member's chosen language, and nothing else.
 *
 * WHY THIS EXISTS. I18nProvider sits at the root of every page, website included, and the
 * only thing it wanted from the profile was one string. Reading it from the profile store
 * meant importing that store, which imports the profile API client, which imports the
 * authenticated fetch wrapper, which imports the Supabase browser client. So 230KB of
 * authentication library was being downloaded by somebody reading the cookie policy.
 *
 * This store deliberately imports nothing but zustand. Do not add an import here that
 * reaches the API, the auth store or Supabase, or the whole point of it is gone.
 *
 * It is written by profile-store, which mirrors the field into here whenever the profile
 * changes. Nothing else should write it.
 */
interface PreferredLanguageState {
  preferredLanguage: string | null;
  setPreferredLanguage: (value: string | null) => void;
}

export const usePreferredLanguageStore = create<PreferredLanguageState>((set) => ({
  preferredLanguage: null,
  setPreferredLanguage: (value) => set({ preferredLanguage: value }),
}));
